import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { ISelectFieldModel } from "../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { useBulkAssignInstructorDialog } from "../hooks/useBulkAssignInstructorDialog";
import { EventPickerMultiSelectField } from "./EventPickerMultiSelectField";
import styles from "./BulkAssignInstructorDialog.module.scss";

interface IBulkAssignInstructorDialogProps {
  visible: boolean;
  employees?: ISelectFieldModel[];
  onHide: () => void;
}

export const BulkAssignInstructorDialog = ({
  visible,
  employees,
  onHide,
}: IBulkAssignInstructorDialogProps) => {
  const {
    form,
    employeeOptions,
    eventOptions,
    isLoadingEvents,
    hasEmployee,
    canSave,
    isSaving,
    handleSave,
  } = useBulkAssignInstructorDialog({ visible, employees, onHide });

  const eventsEmptyMessage = !hasEmployee
    ? "Първо изберете инструктор."
    : isLoadingEvents
      ? "Зареждане..."
      : "Няма предстоящи събития за следващите 30 дни.";

  return (
    <AppDialog
      header="Прехвърляне на класове"
      visible={visible}
      onHide={onHide}
      className={styles.root}
      // Picking an instructor and ticking a month of classes is real work; a stray click on
      // the backdrop must not throw it away. The X is the only way out.
      dismissableMask={false}
      closeOnEscape={false}
    >
      <FormProvider {...form}>
        <form className={styles.root_form}>
          <DefaultFormSelectField
            name="employeeId"
            label="Инструктор"
            required
            options={employeeOptions}
            includeId={false}
            emptyMessage="Няма налични служители."
            filter
            width="100%"
          />

          <EventPickerMultiSelectField
            name="eventIds"
            label="Класове и услуги"
            options={eventOptions}
            disabled={!hasEmployee}
            emptyMessage={eventsEmptyMessage}
          />

          <p className={styles.root_hint}>
            Показват се само предстоящите събития за следващите 30 дни, по
            местното време на обекта. Услугите, които избраният служител няма право
            да извършва, не се показват. Ако класът вече има инструктор, той
            бива заменен.
          </p>

          <div className={styles.root_footer}>
            <DefaultButton
              label="Запази"
              onClick={handleSave}
              disabled={!canSave}
              loading={isSaving}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
